import { Vue, Component } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
@Component({})
export default class EmbryFormOther extends Vue {
  seckillPoint = 1

  openSeckillCart = 0

  mounted() {
    this.getInfo()
  }
  getInfo() {
    IPSService.getGroupInfo().then((response) => {
      localStorage.setItem('skPointsType', response.skPointsType)
      localStorage.setItem('isOpenSkCart', response.isOpenSkCart)
      this.seckillPoint = response.skPointsType
      this.openSeckillCart = response.isOpenSkCart
    });
  }
  save() {
    IPSService.groupSave({
      postParams: {
        skPointsType: this.seckillPoint,
        isOpenSkCart: this.openSeckillCart,
      }
    }).then((res) => {
      res && this.$message.success('保存成功')
      this.getInfo()
    })
  }
  render(h) {
    return (
      <div class="formWrapper">
        <el-form class="formContent" label-width="140px" label-position="left">
          <div class="formItemWrapper">
            <div class="blockTitle">秒杀购物车</div>
            <div class="font-size-14 r-pl-32">
              <el-checkbox v-model={this.openSeckillCart} true-label={1} false-label={0} class="line-height-40">开启秒杀购物车功能</el-checkbox>
              <div class="line-height-40">
                <el-form-item class="text-grey-17" label="秒杀积分订单">
                  <el-radio-group v-model={this.seckillPoint}>
                    <el-radio label={1}>正常积分 </el-radio>
                    <el-radio label={2}>仅触发基础积分，不触发消费激励积分</el-radio>
                    <el-radio label={0}>不积分</el-radio>
                  </el-radio-group>
                  <span class="tip blockTip">1、开启秒杀购物车功能后，秒杀订单的积分规则需统一配置，不再支持基于单商品配置；</span>
                  <span class="tip blockTip">2、如当前商品在CRM积分规则中或消费激励规则中被设置为黑名单，则依然不积分。</span>
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
        <div class="bottomWrapper">
          <el-button size="medium" type="primary" onClick={() => this.save()}>
            保存
          </el-button>
        </div>
      </div>

    );
  }
}
